import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  CircularProgress,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import VSNTypography from "../../shared/VSNTypography";
import VSNButton from "../../shared/VSNButton";
import { toggleModelShow } from "../../shared/CustomFunc";
import VSNModel from "../../shared/VSNModel";
import UploadDocumentModal from "./UploadDocument";
import waiversContainer from "../../container/waivers.container";

const useStyles = makeStyles((theme) => ({
  inviteAdminModel: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: "458px",
      },
    },
  },
  uploadBtn: {
    [theme.breakpoints.down("lg")]: {
      "&.MuiButtonBase-root": {
        padding: "8px 24px",
        minWidth: "unset",
        "& .content": {
          fontSize: 16,
        },
      },
    },
  },
}));

const Waivers = () => {
  const {
    waiversResult,
    waiversLoader,
    handleWaiversClick,
    dispatch,
    modelState,
    handleDocumentDownload,
    downloadLoading,
  } = waiversContainer();
  const classes = useStyles();
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        gap={1}
      >
        <VSNTypography variant="h6" sx={{ fontWeight: 700, fontSize: "24px" }}>
          Waivers
        </VSNTypography>
        <VSNButton
          handleClick={() => dispatch(toggleModelShow("uploadDocumnet"))}
          className={classes.uploadBtn}
          // className={classes.btn}
          startIcon={<FileUploadOutlinedIcon />}
        >
          <span>Upload</span>
        </VSNButton>
      </Stack>
      <TableContainer
        component={Paper}
        sx={{ width: "100%", margin: "auto", px: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>
                Signature Status
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>View & Sign</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {waiversLoader ? (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                  <CircularProgress size={24} color="inherit" />
                </TableCell>
              </TableRow>
            ) : waiversResult?.length > 0 ? (
              waiversResult?.map((waiver, index) => (
                <TableRow key={index}>
                  <TableCell>{waiver?.name}</TableCell>
                  <TableCell>
                    <VSNTypography
                      sx={{
                        padding: "5px 10px",
                        borderRadius: 1.5,
                        width: "max-content",
                        backgroundColor:
                          waiver.signature_status === "Signed"
                            ? "#F2FBF5"
                            : "#FFF8EB",
                        color:
                          waiver.signature_status === "Signed"
                            ? "#34A259"
                            : "#F7A23B",
                      }}
                    >
                      {waiver?.signature_status}
                    </VSNTypography>
                  </TableCell>
                  <TableCell>
                    {waiver?.path ? (
                      <IconButton
                        sx={{ borderRadius: 1.5, backgroundColor: "#F2FBF5" }}
                        onClick={() => handleDocumentDownload(waiver)}
                        disabled={downloadLoading[waiver?.waiver_id]}
                      >
                        {downloadLoading[waiver?.waiver_id] ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          <DownloadOutlinedIcon style={{ color: "#34A259" }} />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton
                        color={
                          waiver.signature_status === "Signed"
                            ? "#8B3F9E"
                            : "#34A259"
                        }
                        sx={{
                          borderRadius: 1.5,
                          backgroundColor:
                            waiver.signature_status === "Signed"
                              ? "#F2E7F5"
                              : "#F2FBF5",
                        }}
                        onClick={() => handleWaiversClick(waiver?.waiver_id)}
                      >
                        {waiver.signature_status === "Pending" ? (
                          <EditOutlinedIcon style={{ color: "#34A259" }} />
                        ) : waiver?.waiver_id === 1 &&
                          waiver.signature_status === "Signed" ? (
                          <EditNoteOutlinedIcon style={{ color: "#8B3F9E" }} />
                        ) : (
                          <VisibilityOutlinedIcon
                            style={{ color: "#8B3F9E" }}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={3}
                  sx={{ textAlign: "center", color: "gray" }}
                >
                  No Waivers Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {modelState?.uploadDocumnet && (
        <VSNModel
          open={modelState?.uploadDocumnet}
          onClose={() => {
            dispatch(toggleModelShow("uploadDocumnet"));
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          className={classes.inviteAdminModel}
        >
          <UploadDocumentModal
            open={modelState?.uploadDocumnet}
            pageName="waiver"
          />
        </VSNModel>
      )}
    </Box>
  );
};

export default Waivers;
